import { Reducer } from "react";

import { IAction } from "@selas/models";
import { AxiosError, AxiosResponse } from "axios";

import { IFileState, initialFileState } from "..";
import Endpoint from "../../services/api/endpoint";

const fileReducer: Reducer<IFileState, IAction> = (state: IFileState = initialFileState, action: IAction): IFileState => {
	switch (action.type) {
		case "REQUEST_GET_" + Endpoint.ProjectParticipantsTemplateFile:
		case "REQUEST_GET_" + Endpoint.OpportunityParticipantsTemplateFile:
		case "REQUEST_GET_" + Endpoint.CevoraMailStatisticsReport:
			state = {
				...state,
				isDownloading: true
			};
			break;
		case "REQUEST_FAILURE_GET_" + Endpoint.ProjectParticipantsTemplateFile:
		case "REQUEST_FAILURE_GET_" + Endpoint.OpportunityParticipantsTemplateFile:
		case "REQUEST_FAILURE_GET_" + Endpoint.CevoraMailStatisticsReport: {
			const payload: { error: AxiosError } = action.payload as { error: AxiosError };
			state = {
				...state,
				downloadError: payload.error
			};
			break;
		}
		case "REQUEST_SUCCESS_GET_" + Endpoint.ProjectParticipantsTemplateFile:
		case "REQUEST_SUCCESS_GET_" + Endpoint.OpportunityParticipantsTemplateFile:
		case "REQUEST_SUCCESS_GET_" + Endpoint.CevoraMailStatisticsReport: {
			const payload: { response: AxiosResponse } = action.payload as { response: AxiosResponse };

			if (action.payload && payload.response && payload.response.data) {
				const contentDisposition: string = payload.response.headers["content-disposition"];
				const match: RegExpMatchArray = contentDisposition.match(/filename\s*=\s*(.+);/i);
				const filename: string = match[1];

				state = {
					...state,
					downloadFile: payload.response.data,
					filename
				};
			}
			break;
		}
		case "REQUEST_END_GET_" + Endpoint.ProjectParticipantsTemplateFile:
		case "REQUEST_END_GET_" + Endpoint.OpportunityParticipantsTemplateFile:
		case "REQUEST_END_GET_" + Endpoint.CevoraMailStatisticsReport:
			state = {
				...state,
				isDownloading: false
			};
			break;
	}

	return state;
};

export default fileReducer;
